<template>
  <div class="legend-section">
    <v-expansion-panels dark accordion>
      <v-expansion-panel>
        <!-- <v-layout wrap>
          <v-flex xs12 md12>
            <h2 class="legend-top-title">Legend</h2>
          </v-flex>
        </v-layout> -->
        <v-expansion-panel-header>
          <h2 class="legend-top-title">Legend</h2>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-layout wrap>
            <!-- <v-flex class="legend-left-section" xs12 md6>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <h3 class="side-title">{{leftTitle}}</h3>
                </v-flex>
                <v-flex xs12 md12>
                  <div>
                    <v-simple-table class="legend-table" dark>
                      <template v-slot:default>
                        <tbody>
                          <tr
                            v-for="item in leftSections"
                            :key="item.title"
                          >
                            <td>
                              <h3 class="title mt-3 mb-0">{{ item.title }}</h3>
                              <div class="caption">{{ item.description }}</div>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md1></v-flex> -->
            <v-flex class="legend-right-section" xs12 md12>
              <!-- <v-layout wrap>
                <v-flex xs12 md12>
                  <h2 class="legend-title">Legend</h2>
                </v-flex>
              </v-layout> -->
              <v-layout wrap>
                <v-flex xs12 md12>
                  <h3 class="side-title">{{rightTitle}}</h3>
                </v-flex>
                <v-flex xs12 md12>
                  <div>
                    <v-simple-table class="legend-table" dark>
                      <template v-slot:default>
                        <tbody>
                          <tr
                            v-for="item in rightSections"
                            :key="item.title"
                          >
                            <td>
                              <h3 class="title mt-3 mb-0">{{ item.title }}</h3>
                              <div class="caption">{{ item.description }}</div>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout wrap v-if="showleftSideIcon">
            <v-flex xs6 md6>
              <v-img src='/static/img/instagram.png' class="float-left mt-2" width="64px"></v-img>
            </v-flex>
            <v-flex xs6 md6>
              <v-img src='/static/img/kobe_white.png' class="float-right" width="72px"></v-img>
            </v-flex>
          </v-layout>
          <v-layout wrap v-else>
            <v-flex xs12 md12>
              <v-img src='/static/img/kobe_white.png' class="float-right" width="72px"></v-img>
            </v-flex>
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
export default {
  name: 'legend-section',
  props: ['leftTitle', 'rightTitle', 'leftSections', 'rightSections', 'showleftSideIcon'],
  data () {
    return {
    }
  }
}
</script>
<style lang="css">
  .legend-section {
    padding-top: 20px;
    color: #fff;
  }
  .legend-section .v-expansion-panel-header{
    background-color: rgb(33, 33, 33);
    border-color: rgb(33, 33, 33);
  }
  .legend-section .v-expansion-panel-content {
    background-color: black;
    border: 1px solid rgb(33, 33, 33);
  }
  .legend-section .legend-top-title {
    /* display: none; */
    /* float: right; */
    font-size: 1.25rem;
    font-weight: 500;
    padding: 0;
    margin: 0;
    /* padding-bottom: 20px; */
  }
  .legend-section .legend-title {
    float: right;
    font-size: 2.5rem;
    font-weight: 600;
    margin-top: -40px;
    padding-bottom: 20px;
  }
  .legend-section .side-title {
    /* transform: rotate(-90deg); */
    padding-left: 15px;
    font-style: italic;
    font-weight: 900;
    /* white-space: nowrap; */
    /* margin-top: 100px;
    margin-right: -25%; */
  }
  .legend-section .legend-table .title {
    font-weight: 500;
  }
  .legend-section .legend-table table {
    border: 2px solid #1e1e1e;
  }
  .legend-section .legend-table table td {
    background-color: #000;
  }
  .legend-section .legend-table .caption {
    font-size: 13px!important;
    font-style: italic;
    padding-bottom: 20px;
    font-weight: 300;
  }
  .legend-section .title {
    font-size: 20px;
    color: rgb(255, 183, 77);
    padding-bottom: 5px;
  }
  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 800px) {
    .legend-section {
      padding-top: 30px;
    }
    .legend-section .legend-left-section {
      padding-bottom: 30px;
    }
    .legend-section .legend-top-title {
      display: block;
    }
    .legend-section .legend-title {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// Legend.vue?6decf022